import { render, staticRenderFns } from "./RegisterDeviation.vue?vue&type=template&id=848d4bde&scoped=true&"
import script from "./RegisterDeviation.vue?vue&type=script&lang=js&"
export * from "./RegisterDeviation.vue?vue&type=script&lang=js&"
import style0 from "./RegisterDeviation.vue?vue&type=style&index=0&id=848d4bde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848d4bde",
  null
  
)

export default component.exports